// ============================================================================
// Réglages du QR code imprimé au verso d'une SKILLCARD.
// ============================================================================
// Partagés par l'IMAGE (verso, `@jeraisonne/ui/tool-cards`) et la VÉRIFICATION
// avant impression (`apps/app/src/lib/cards/qr-check.ts`) : une seule source,
// l'image testée est l'image imprimée.
//
// Correction Q (tâches, pliures), zone calme 4 modules, QR STANDARD : modules
// sombres sur fond blanc (tuile blanche bordée de la teinte de la carte) — le
// contraste le plus sûr pour tous les lecteurs.
// ============================================================================

export const CARD_QR_OPTIONS = {
  errorCorrectionLevel: 'Q',
  margin: 4,
  color: { dark: '#111111', light: '#ffffff' },
} as const;
